module.exports = __webpack_public_path__ + "assets/img/tit6.1be791b8.png";